import { Image } from "lucide-react";
import React from "react";
import { useRef } from "react";
export default function FileUploadButton(props) {
    const fileInputRef = useRef(null);
    const handleClick = () => {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click(); // Kích hoạt file picker
    };
    const handleFileChange = event => {
        var _a;
        const files = event.target.files;
        if (files && files.length > 0) {
            (_a = props === null || props === void 0 ? void 0 : props.callback) === null || _a === void 0 ? void 0 : _a.call(props, files);
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
        className: "cs-button cs-button--right",
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement(Image, null)), /*#__PURE__*/ React.createElement("input", {
        multiple: true,
        type: "file",
        ref: fileInputRef,
        accept: "image/*",
        onChange: handleFileChange,
        className: "hidden"
    }));
}
;
